module.exports = __webpack_public_path__ + "static/img/rail_transit.7d58f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/rail_transit.jpg
// module id = yC4A
// module chunks = 0